export default "__VITE_ASSET__DiMV6uBz__"